"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const localStorage_helps_1 = __importDefault(require("./helps/localStorage.helps"));
const interface_1 = require("./helps/interface");
const processRespons_1 = __importDefault(require("./helps/processRespons"));
const login = () => {
    try {
        const loginForm = document.querySelector('.login__form');
        if (loginForm) {
            const button = loginForm.querySelector('button');
            button.addEventListener('click', submitButton);
            function submitButton(e) {
                e.preventDefault();
                const login = loginForm.login.value;
                const password = loginForm.password.value;
                const loginPassword = {
                    email: login,
                    password
                };
                if (login && password) {
                    fetch(interface_1.Link.LoginAdmin, {
                        method: 'POST',
                        body: JSON.stringify(loginPassword),
                        headers: { 'Content-type': 'application/json' }
                    })
                        .then(res => res.json())
                        .then((res) => {
                        if ('error' in res) {
                            return (0, processRespons_1.default)(res);
                        }
                        localStorage_helps_1.default.saveDataLogin(res);
                        window.location.href = '/admin-options.html';
                    })
                        .catch(error => console.log('Error in fetch in fnction login >>>', error));
                }
                console.log(login, password);
            }
        }
    }
    catch (error) {
        console.log('Error in Function  login >>> ', error);
    }
};
exports.default = login;
